export default __webpack_public_path__ + "static/media/promo-karyawan.be5565a3.png";